module.exports = __webpack_public_path__ + "img/feature-tile-icon-01.d34f57d9.svg";